import React, { useState } from 'react';
//import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import Header from '../../components/header';
import TitlePage from '../../components/title-page';

export default function ImportPublisher() {
    const [file, setFile] = useState();
    const [array, setArray] = useState([]);
    const [uploadStatus, setUploadStatus] = useState("");
    const [isFileImported, setIsFileImported] = useState(false);
    const fileReader = new FileReader();
    const handleOnChange = (e) => {
        setFile(e.target.files[0]);
    };

    const csvFileToArray = string => {
        const csvHeader = string.slice(0, string.indexOf("\n")).split(",");
        const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");

        const newArray = csvRows.map(i => {
            const values = i.split(",");
            const obj = csvHeader.reduce((object, header, index) => {
                object[header] = values[index];
                return object;
            }, {});
            return obj;
        });

        setArray(newArray);
    };

    const handleOnSubmit = async (e) => {
        e.preventDefault();

        if (isFileImported) {
            try {
                setUploadStatus("Uploading data...");
                for (const item of array) {
                    const {
                        "Publisher Name": name,
                        "Email": email,
                        "Phone Number": phone,
                        "Tags": tags,
                        "Contact Name": contact_name,
                        "Contact Last Name": contact_last_name
                    } = item;

                    await api.post("publishers", {
                        name,
                        email,
                        phone,
                        tags,
                        contact_name,
                        contact_last_name
                    });
                }
                setUploadStatus("Data uploaded successfully");
                window.location.href = '../list-publishers/1';
            } catch (error) {
                console.error("Error uploading data:", error);
                setUploadStatus("Imported! Some Data Could Not be Loaded Correctly");
            }
        } else {
            if (file) {
                fileReader.onload = function (event) {
                    const text = event.target.result;
                    csvFileToArray(text);
                    setIsFileImported(true);
                    setUploadStatus("Data loaded. Click 'Import Publishers' to upload.");
                };
                fileReader.readAsText(file);
            }
        }
    };

    return (
        <div data-page="import-publisher">
            <Header />
            <TitlePage title="Import Publishers" />
            <div className="container-fluid" data-component="content-importpublisher">
                <div className="container gutter">
                    <h2>Import Publisher List</h2>
                    <br />
                        <a href='../list-publishers/1' className="btn blue-light btn-save">
                            Back to Publishers
                        </a>
                        &nbsp;
                        <a href='../publisher/0' className="btn blue-light btn-save">
                            New Publisher
                        </a>
                        <br />
                        <br />
                    <p><strong>Important!</strong> To load all data, it is necessary to upload a CSV file.</p>
                    <br />
                    <form onSubmit={handleOnSubmit}>
                        <input
                            className='btn'
                            type={"file"}
                            id={"csvFileInput"}
                            accept={".csv"}
                            onChange={handleOnChange}
                        />
                        <br />
                        <br />
                        <button type="submit" className="btn blue-light btn-save">
                            {isFileImported ? "Import Publishers" : "Load Data"}
                        </button>
                        <br />
                    </form>
                    <br />
                    {uploadStatus && <p>{uploadStatus}</p>}
                    {array.length > 0 && (
                        <div className='container-table'>
                            <div className='responsive-table'>
                                <br />
                                <center>
                                <table className='responsive-table'>
                                    <thead>
                                        <tr className='table-header col col-1'>
                                            {Object.keys(array[0]).map((key) => (
                                                <th key={key}>{key} | &nbsp;</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {array.map((item, index) => (
                                            <tr className='table-row' key={index}>
                                                {Object.values(item).map((val, idx) => (
                                                    <td className='col col-1' key={idx}>{val}</td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                </center>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
